export const USER_TYPES = {
  CUSTOMER: "customer",
  AGENT: "agent",
  EMPLOYEE: "employee",
  RETENTION: "retention",
};

export const APP_NAMES = {
  IPDS: "IPDS",
  CRM: "CRM",
  PACE: "PACE",
  WHATSAPP_BOT: "WHATSAPP_BOT",
  CUSTOMER_WEB: "CUSTOMER_WEB",
  EMARINE: "EMARINE",
  SUPERAPP: "SUPER_APP",
};

export const PRODUCT_NAME_UIN_MAP = {
  "Criti-Medicare": "TATHLIP22176V012122",
  // "MediCare":"TATHLIP23118V032223",
  "Medicare Plus": "TATHLIP21253V022021",
  "Group MediCare 360": "TATHLGP22162V012122",
  "Elder Care": "TATHLIP23179V012223",
  "Group Medicare Micro Insurance Product": "TATHMGP21533V022021",
  "Group Medicare": "TATHLGP21248V022021",
};
export const PRODUCT_NAME_UIN_MAP_MEDICARE = {
  MediCare: "TATHLIP21224V022021",
  Medicare: "TATHLIP21224V022021",
  "Revised MediCare": "TATHLIP23118V032223",
  "Revised Medicare": "TATHLIP23118V032223",
  "Medicare Protect": "TATHLIP26053V042526",
  "Medicare Premier": "TATHLIP18005V011819",
  "Revised Medicare Premier": "TATHLIP24159V042324",
  "Revised MediCare Premier": "TATHLIP24159V042324",
  "Medicare Premier Plan A": "TATHLIP24159V042324",
  "Medicare Premier Plan A Plus": "TATHLIP24159V042324",
  "Premier - Medicare": "TATHLIP18005V011819",
  "Protect - Medicare": "TATHLIP26053V042526",
  "Tata Aig Medicare Premier": "TATHLIP26052V052526",
  "Tata Aig Medicare": "TATHLIP26053V042526",
  "Medicare Select": "TATHLIP25051V012425",
  "Health Supercharge": "TATHLIP24113V012324",
};

export const NEW_PRODUCT_NAME_UIN_MAP_MEDICARE = {
  "Premier - Medicare": "TATHLIP26052V052526",
  MediCare: "TATHLIP26053V042526",
  Medicare: "TATHLIP26053V042526",
  "Tata Aig Medicare Premier": "TATHLIP26052V052526",
  "Tata Aig Medicare": "TATHLIP26053V042526",
  "Medicare Select": "TATHLIP25051V012425"
};

export const PRODUCT_NAME_LABEL_MAP = {
  "Criti-Medicare": "productName_criti_medicare",
  // "MediCare":"TATHLIP23118V032223",
  "Medicare Plus": "productName_medicareplus",
  "Group MediCare 360": "productName_gmc360",
  "Group Medicare": "productName_gmc",
  "Elder Care": "productName_elderCare",
  "Medicare Select": "productName_MedicareSelect"
};

export const PRODUCT_NAME_LABEL_MAP_MEDICARE = {
  Medicare: "productName_Medicare",
  MediCare: "productName_Medicare",
  "Revised Medicare": "productName_MedicareRevised",
  "Revised MediCare": "productName_MedicareRevised",
  "Medicare Protect": "productName_Medicare",
  "Protect - Medicare": "productName_Medicare",
  "Medicare Premier": "productName_MedicarePremierPlanA",
  "Revised Medicare Premier": "productName_MedicarePremierPlanA",
  "Medicare Premier Plan A": "productName_MedicarePremierPlanA",
  "Medicare Premier Plan A Plus": "productName_MedicarePremierPlanAPlus",
  "Premier - Medicare": "productName_MedicarePremierPlanAPlus",
  "Tata Aig Medicare Premier": "productName_MedicarePremierPlanA",
  "Tata Aig Medicare": "productName_Medicare",
  "Medicare Select": "productName_MedicareSelect",
  "Health Supercharge": "productName_HealthSupercharge",
  "Medicare Select Smart": "productName_MedicareSelectSmart",
  "Medicare Select Elite": "productName_MedicareElite",
};

export const SCHEME_TYPE = {
  As_Is: "As Is",
  Higher_SI_Slab: "Higher SI Slab 1",
};

export const INCORRECT_OTP_ATTEMPTS = {
  "you have 1 more attempts left": "1",
  "you have 2 more attempts left": "2",
  "you have 3 more attempts left": "3",
  "you have 4 more attempts left": "4",
};

export const LOB = {
  MOTOR: "motor",
  HEALTH: "health",
  TRAVEL: "travel",
};

export const INTENT = {
  RENEW_POLICY: "RENEWAL_HEALTH",
  RENEW_QUOTE: "RENEWAL_HEALTH_QUOTE",
  GROUP_RENEW_QUOTE: "GROUP_RENEWAL_HEALTH_QUOTE",
  SUPPER_APP_RENEW_PAGE: "RENEWAL_SUPERAPP",
};

export const BOLT_QUOTE_REDIRECTION = {
  URL: "redirection?",
  BOLT_SOURCE: "RENEWALVAULT",
  BOLT_SALT: "o6aaqycnw0dd1111",
  RV_BOLT_QUOTE_API_URL: "/renewal/health/save-quote",
  BOLT_INTENT: "RENEWAL",
  BOLT_ACTION: "edit",
};

export const HTTP_STATUS_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  OK: 200,
  CREATED: 201,
  WEB_OK: "[200]",
};

export const POLICY_STATUS = {
  PENDING: "PENDING",
  PAYMENT_PENDING: "PAYMENT PENDING",
  POLICY_ISSUANCE_PENDING: "ISSUANCE PENDING",
  POLICY_ISSUANCE_RETRY: "ISSUANCE RETRY",
  POLICY_ISSUED: "POLICY ISSUED",
  POLICY_ISSUANCE_FAILED: "ISSUANCE FAILED",
  NSTP_TRIGGERED: "NSTP TRIGGERED",
};

export const PAYMENT_STATUS = {
  SUCCESS: "Success",
  FAILED: "Failed",
  PENDING: "Pending",
};

export const PUBLIC_PATHS = ["/search-policy", "/redirection"];

export const RESOURCE_ROUTE_MAP = {
  RENEWAL_HEALTH: ["/quote", "/proposal"],
};

export const MESSAGES = {
  DEFAULT_MESSAGE:
    "Oops! This shouldn't have happened. We are working to get this fixed as soon as we can. Request you to try again in some time.",
  CKYC_ERROR_MESSAGE:
    "You have to use another method for your E-KYC Verification! Need assistance? Call 18002676115",
};

export const MESSAGE_TYPES = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
};

export const OTP_MESSAGES = {
  VERIFIED: "OTP verification successful.",
  EXPIRED: "OTP has expired",
  EXHAUSTED: "You have exhausted the permissible number of retries",
  RESEND_TIME: 120,
  TOTAL_ATTEMPTS: 5,
};

export const RADIO_OPTIONS = [
  { value: "1", label: "1 Year", addInfo: "" },
  { value: "2", label: "2 Years", addInfo: "Save 5%" },
  { value: "3", label: "3 Years", addInfo: "Save 10%" },
];

export const RISK_TYPE_ORDER = [
  "Self",
  "Spouse",
  "DependentChild1",
  "DependentChild2",
  "DependentChild3",
  "DependentParent1",
  "DependentParent2",
  "DependentParentInLaw1",
  "DependentParentInLaw2",
];

export const GLOBAL_PRODUCER_ROLES = ["customersupportretention"];
export const REGEX = {
  PANCARD_REGEX: /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
  AADHAR_REGEX: /^\d{12}$/,
  CKYCNUMBER_REGEX: /^\d{14}$/,
  PASSPORT_REGEX: /^([a-zA-Z]){1}([0-9]){7}$/,
  PASSPORT_FILE_REGEX: /^[a-zA-Z0-9]*$/,
  DL_REGEX: /^[A-Z0-9]{1,15}$/i,
  VOTERID_REGEX: /^([a-zA-Z]){3}([0-9]){7}$/,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MOBILE_REGEX: /^[0-9]{10}$/,
  ALPHABETICAL: /^[A-Za-z]+$/,
  DATE: /^[0-9/-]+$/,
};

export const govtIDType = {
  DRIVINGLICENCE: "",
  PASSPORTFILENUMBER: "",
  PASSPORTNUMBER: "",
  CKYCNUMBER: "",
  AADHAARNUMBER: "",
};

export const PRODUCT_TYPE = {
  GROUP: "Group",
  RETAIL: "Retail",
};

export const UTM_MEDIUM = [
  "digital_upsell",
  "sms",
  "email",
  "whatsapp",
  "taxsaving",
  "ep",
  "salary",
  "upsell",
  "earlyrenewal",
  "email_websitedrop",
  "sms_websitedrop",
];
export const DROPDOWN = {
  MR: "Mr",
  MISS: "Miss",
};

export const HEIGHT_INCHES_OPTIONS = [
  { id: 1, value: 0 },
  { id: 2, value: 1 },
  { id: 3, value: 2 },
  { id: 4, value: 3 },
  { id: 5, value: 4 },
  { id: 6, value: 5 },
  { id: 7, value: 6 },
  { id: 8, value: 7 },
  { id: 9, value: 8 },
  { id: 10, value: 9 },
  { id: 11, value: 10 },
  { id: 12, value: 11 },
];

export const HEIGHT_FEET_OPTIONS = [
  { id: 1, value: 1 },
  { id: 2, value: 2 },
  { id: 3, value: 3 },
  { id: 4, value: 4 },
  { id: 5, value: 5 },
  { id: 6, value: 6 },
  { id: 7, value: 7 },
  { id: 8, value: 8 },
];

export const MEMBER_DETAILS_DROPDOWN = {
  HEIGHT_CATEGORY: [
    { id: 1, value: "Feet & Inches" },
    { id: 2, value: "CM" },
  ],
  OPERATIVE_STATUS: [
    { id: 1, value: "Unoperated" },
    { id: 2, value: "Operated" },
  ],
  TYPE_OF_SURGERY: [
    { id: 1, value: "Hysterectomy" },
    { id: 2, value: "Myomectomy" },
    { id: 3, value: "Unilateral" },
    { id: 4, value: "Bilateral" },
    { id: 5, value: "Unilateral removal" },
  ],
  TREATMENT_STATUS: [
    { id: 1, value: "Cured" },
    { id: 2, value: "Not cured" },
  ],
  COMPLICATIONS: [
    { id: 1, value: "No" },
    { id: 2, value: "Yes" },
  ],
  MEDICATION_HISTORY: [
    { id: 1, value: "Regular/Irregular" },
    { id: 2, value: "Regular" },
  ],
  PROGRESS: [
    { id: 1, value: "Uncontrolled" },
    { id: 2, value: "Controlled" },
    { id: 3, value: "Regular/Irregular" },
  ],
  MODE_OF_MEDICATION: [
    { id: 1, value: "Oral" },
    { id: 2, value: "Injectable" },
    { id: 3, value: "Regular/Irregular" },
  ],
};

export const PLAN_TYPE = {
  INDIVIDUAL: "Individual Basis",
  FLOATER: "FLOATER",
};

export const PRODUCT_CODE = {
  MEDICARE: 2888,
  MEDICARE_PLUS: 2896,
  CRITI_MEDICARE: 2804,
  ELDER_CARE: 2833,
};

export const FLOATER_PLAN_TYPE = ["Floater", "Floater Basis"];

export const BOLT_POLICY_SUB_STATUS = [
  "kycpending",
  "customerconsentpending",
  "paymentpending",
];

export const BOLT_AFTER_PAYMENT_SUB_STATUS = [
  "counterofferinitiated",
  "additionalinforequired",
  "refertocops",
  "refertouw",
];

export const STATUS_INTENT_MAPPING = {
  additionalinforequired: "PENDING_DOCS_POLICY",
  counterofferinitiated: "COL_POLICY",
  kycpending: "PROPOSAL_POLICY",
  customerconsentpending: "PROPOSAL_POLICY",
  refertocops: "PROPOSAL_POLICY",
  refertouw: "PROPOSAL_POLICY",
  // reject: "PROPOSAL_POLICY",
  paymentpending: "PROPOSAL_POLICY",
};

export const MIGRATION_PRODUCER_ROLES = ["customersupportretention"];

export const PRICE_REVISION_VARIANT = {
  medicare: "Medicare",
  revisedmedicare: "Medicare",
  medicarepremier: "Premier - Medicare",
  revisedmedicarepremier: "Premier - Medicare",
  medicarepremierplana: "Premier - Medicare",
  medicarepremierplanaplus: "Premier - Medicare",
};

export const PRICE_REVISION_CUTOFF_DATE = {
  MAY: "2025-05-31T23:59:59",
  JULY: "2025-07-27T23:59:59",
  JULY_POST: "2025-07-28T23:59:59",
};

export const CKYC_PAN_MSG = [
  "CKYC not completed. Please retry with another id",
  "successfully completed",
];

export const APP_RATING = [
  { value: "4.5 ★", label: "Android" },
  { value: "4.6 ★", label: "IOS" },
  { value: "2m +", label: "Users" },
];
export const WEB_PRODUCER_CODES = [
  "0000192004",
  "0007652001",
  "0007652002",
  "0007652003",
  "0014851000",
  "0014851001",
  "0019024001",
  "0025976000",
  "0025976001",
  "0035539000",
  "0035540000",
  "0035541000",
  "0035542000",
  "0036286000",
  "0039110000",
  "0007652000",
  "1697854000",
  "1697855000",
  "0010805000",
  "0010805003",
  "1944770000",
  "2106620000",
  "2655140000",
  "2581980000",
  "2722600000",
  "2722610000",
  "2773370000",
  "2773380000",
];

export const MEDICARE_GENERIC_CODES = [2888, 2848, 2846];

export const PACKAGES_COVERS_ENABLED_SUBPRODUCT_CODES = new Set(["28572", "2846", "28582"]);
export const MEDICARE_SELECT_CODE = ["28572", "28582"];
export const MEDICARE_SELECT_REVISION_CODE = "28582";
export const MEDICARE_SELECT_SUBPRODUCT_UIN_MAP = {
  "28572": "TATHLIP25051V012425",
  "28582": "TATHLIP27061V022627",
};
export const HEALTH_SUPERCHARGE_CODE = "2846";
export const GEO_PLAN = "Geo Plan";
export const VALUE_PLAN = "Value Plan";
export const ROOM_CATEGORY_SINGLE_PRIVATE = "Single Private";
export const MEDICARE_PREMIER_SUBPRODUCT_CODE = "28575"
export const ROOM_CATEGORY_ALL_COVERED = "All Room Categories Covered";
export const ROOM_CATEGORY_TWIN_SHARING = "Twin Sharing Accomodation";
export const MEDICARE_SELECT_SMART_VARIANT_NAME = "MediCare Select Smart";
export const MEDICARE_SELECT_ELITE_VARIANT_NAME = "MediCare Select Elite";

export const GRIEVANCE_REDRESSAL_LINK = "https://www.tataaig.com/grievance-redressal-policy";

export const getCISLink = (data) => {
  const { productCode, subProductCode, variant } = data;
  const isMedicareSelect = MEDICARE_SELECT_CODE.includes(String(subProductCode));
  const isHealthSuperchargeGeopPlan = String(productCode) === HEALTH_SUPERCHARGE_CODE && variant.toLowerCase() === GEO_PLAN.toLowerCase();
  const isHealthSuperchargeValuePlan = String(productCode) === HEALTH_SUPERCHARGE_CODE && variant.toLowerCase() === VALUE_PLAN.toLowerCase();
  const isElderCare = productCode === PRODUCT_CODE.ELDER_CARE;
  const isCritiMedicare = productCode === PRODUCT_CODE.CRITI_MEDICARE;
  const isMedicarePlus = productCode === PRODUCT_CODE.MEDICARE_PLUS;
  const isMedicarePremier = String(subProductCode) === MEDICARE_PREMIER_SUBPRODUCT_CODE;

  if(isMedicareSelect) return "https://www.tataaig.com/s3/medicare_select_cis_e7df7ce2ec.pdf";
  else if(isHealthSuperchargeValuePlan) return "https://www.tataaig.com/s3/health_supercharge_value_plan_cis_ec515c4464.pdf";
  else if(isHealthSuperchargeGeopPlan) return "https://www.tataaig.com/s3/health_supercharge_geo_plan_cis_c853045b33.pdf";
  else if(isElderCare) return "https://www.tataaig.com/s3/Tata_AIG_Elder_Care_CIS_a1c17bf958.pdf";
  else if(isCritiMedicare) return "https://www.tataaig.com/s3/Tata_AIG_Criti_Medicare_CIS_ac9735ff08.pdf";
  else if(isMedicarePlus) return "https://www.tataaig.com/s3/Medi_Care_Plus_eef8916f2b.pdf";
  else if(isMedicarePremier) return "https://www.tataaig.com/s3/TATA_AIG_Medicare_Premier_Customer_information_Sheet_2e2c10e8d0.pdf";
  else return "https://www.tataaig.com/s3/Tata_AIG_Medi_Care_CIS_08824d8e97.pdf";
}

export const PRIVACY_POLICY_LINK = "https://www.tataaig.com/privacy-policy";